<script>
    import { PRConnect } from "@projectroom/ui-lib";
    import Select from "svelte-select";
    import { onDestroy, onMount } from "svelte";
    import axios from "axios";
    import ScenarioCharImage from "./../components/ScenarioCharImage.svelte";
    import ScenarioContext from "./../components/ScenarioContext.svelte";
    import ScenarioButton from "./../components/ScenarioButton.svelte";
    import ScenarioBackground from "./../components/ScenarioBackground.svelte";
    import CharImageModal from "./../components/CharImageModal.svelte";
    import RightBlock from "./../components/RightBlock.svelte";
    import ChatLink from "./../components/ChatLink.svelte";

    export let bot;

    const BUTTON_TYPE_FIX = "FIX";
    const BUTTON_TYPE_DEFAULT = "DEFAULT";
    const FLAG_Y = "Y";
    const FLAG_N = "N";

    const itemId = "id";
    const label = "actionName";
    const title = "title";
    let searchable = false;
    const items = [
        { value: "CREATE", label: "➕ 스토리 시나리오 추가하기" },
        {
            value: "SCENARIO",
            label: "다음단계로 넘어갈 페이지를 지정해주세요!",
        },
        { value: "LINK", label: "버튼에 적용할 링크 주소를 입력해주세요!" },
        {
            value: "IFRAME",
            label: "버튼에 적용할 유튜브 링크 주소를 입력해주세요!",
        },
    ];

    let floatingConfig = {
        strategy: "fixed",
    };

    let buttonImageInfo = {
        id: "",
        buttonImageContent: "",
        buttonImageType: "ICON",
    };

    let refFixedButtonList = [];
    let imageUploadRef;
    let titleFlag = true;
    let charActionFlag = true;
    let isButtonImagePopup = false;
    let isButtonIconPopup = false;
    let buttonImageBind;
    let targetButtonId;
    let targetImageName;
    let charImageModal;
    let charImageModalList = [];

    let iconImageList = {
        insta: false,
        facebook: false,
        kakaotalk: false,
        blog: false,
        youtube: false,
        twitter: false,
        mail: false,
        shop: false,
    };
    let iconImageRef = {};
    let openCount = 0;

    $: if (bot.defaultChar.activeScenario.type == "START") {
        jQuery(".talk-fixed-button-ul").sortable({
            stop: function (event, ui) {
                document
                    .querySelectorAll(".fix-ordered-button")
                    .forEach((e, idx) => {
                        const id = e.dataset.id;
                        bot.defaultChar.activeScenario.changeButtonSeq(
                            id,
                            idx,
                            BUTTON_TYPE_FIX,
                        );
                    });
            },
        });
        if (openCount === 0) {
            jQuery(".builder-editor-scroll").animate({ scrollTop: 0 }, 500);
            openCount++;
        }
    }

    const changeButtonOption = (event, index, type) => {
        const targetType = event.detail.value;

        if (
            targetType === "SCENARIO" ||
            targetType === "LINK" ||
            targetType === "IFRAME"
        ) {
            bot.defaultChar.activeScenario.changeButtonTargetType(
                targetType,
                index,
                type,
            );
        } else {
            bot.defaultChar.addScenario(true, index);
        }
    };

    const changeScenario = (e, index, type) => {
        const scenarioId = e.detail.id;
        bot.defaultChar.activeScenario.changeTargetScenario(
            scenarioId,
            index,
            type,
        );
    };

    const changeButtonTargetLink = (e, index, buttonType, linkType) => {
        let targetLink = e.target.value;
        if (linkType === "IFRAME" && targetLink.includes("watch")) {
            const urlObject = new URL(targetLink);
            targetLink = `${urlObject.origin}/embed/${urlObject.searchParams.get("v")}`;
        } else if (linkType === "IFRAME" && targetLink.includes("youtu.be")) {
            const urlObject = new URL(targetLink);
            targetLink = `https://www.youtube.com/embed${urlObject.pathname}`;
        }
        bot.defaultChar.activeScenario.changeButtonTargetLink(
            targetLink,
            index,
            buttonType,
            linkType,
        );
    };

    const clickScenarioButtonAdd = (scenario) => {
        // 권한 체크 해야하는 부분
        scenario.addButton();
    };

    const changeButtonImage = (buttonId, imageContent, imageType, func) => {
        bot.defaultChar.activeScenario.changeButtonImage(
            buttonId,
            imageContent,
            imageType,
            func,
        );
    };

    const changeButtonImageType = (buttonId, imageType) => {
        bot.defaultChar.activeScenario.changeButtonImageType(
            buttonId,
            imageType,
        );
    };

    const clickScenarioAdd = () => {
        if (!bot.isAuthority("storyCnt", bot.getScenarioListSize() + 1)) {
            return false;
        }
        bot.defaultChar.addScenario();
    };

    const changeCharAction = (e) => {
        bot.defaultChar.activeScenario.changeCharAction(e.detail.id);
    };

    const changeScenarioTitle = (e) => {
        bot.defaultChar.activeScenario.changeTitle(e.target.value);
    };

    const clickMoveScenario = (senarioId) => {
        bot.defaultChar.setActiveScenario(senarioId);
    };

    const changeIframeChatMessageOutline = (flag) => {
        const chatMessage = document
            .getElementById("mobile-frame")
            .contentWindow.document.querySelector(".chat-message");
        if (!flag) {
            chatMessage.style.outline = "none";
            chatMessage.style.marginLeft = "none";
            chatMessage.style.marginRight = "none";
            chatMessage.style.borderRadius = "none";
            return;
        }
        chatMessage.style.outline = "4px dashed #DBDDEC";
        chatMessage.style.marginLeft = "20px";
        chatMessage.style.marginRight = "20px";
        chatMessage.style.borderRadius = "12px";
    };

    const changeBotActionName = (e) => {
        const index = e.target.dataset.index;
        const actionName = e.target.value;
        bot.defaultChar.changeCharActionActionName(index, actionName);
    };

    const clickButtonImageCreate = (buttonId, index) => {
        buttonImageBind.buttonId = buttonId;
        buttonImageBind.click();
    };

    const clickButtonImageAssign = () => {
        const { id, buttonImageType } = buttonImageInfo;
        changeButtonImageType(id, buttonImageType);
        isButtonImagePopup = false;
    };

    const clickButtonImageModify = (id) => {
        targetButtonId = id;
        PRConnect.send("/api/Message/getButtonImageContent", { id }, (data) => {
            if (data.header.status === "success") {
                //const $buttonImageLayer = jQuery("#buttonImagePopup");
                //$buttonImageLayer.prop("src", `${data.result.buttonImageContent}?${date.getTime()}`);
                buttonImageInfo = { ...data.result };
                isButtonImagePopup = true;
            }
        });
    };

    const clickButtonImageDelete = () => {
        isButtonImagePopup = false;
        bot.defaultChar.activeScenario.deleteButtonImage(buttonImageInfo.id);
    };

    onMount(() => {});

    const onImageFileSelected = (e) => {
        isButtonIconPopup = false;
        let buttonId = targetButtonId;
        let image = e.target.files[0];
        onFileUpload(buttonId, image);
    };

    const onIconFileSelected = (file) => {
        onFileUpload(targetButtonId, file);
    };

    const onFileUpload = (buttonId, image) => {
        const key = `${bot.bot2DChar.botId}/button-images/${buttonId}/${image.name}`;
        const type = image.type;
        PRConnect.send(
            "/api/File/uploadPresignedUrl",
            { key, type },
            (data) => {
                axios
                    .put(data.result, image, {
                        headers: { "Content-Type": type },
                    })
                    .then((response) => {
                        changeButtonImage(
                            buttonId,
                            image.name,
                            "ICON",
                            clickButtonImageModify,
                        );
                    });
            },
        );
    };

    const clickAddFlagCheckbox = (index, flag) => {
        const addFlag = flag === FLAG_Y ? FLAG_N : FLAG_Y;
        bot.defaultChar.changeCharActionAddFlag(index, addFlag);
    };

    const clickIconImage = (buttonId) => {
        isButtonIconPopup = true;
        for (let i in iconImageList) {
            iconImageList[i] = false;
        }
        targetButtonId = buttonId;
    };

    const clickIconImageSelected = (e) => {
        const type = e.target.dataset.type;
        for (let i in iconImageList) {
            iconImageList[i] = false;
        }
        iconImageList[type] = true;
    };

    const clickIconImageSubmit = () => {
        const type = Object.entries(iconImageList).find((e) => e[1] == true)[0];
        const imageContent = `a-${type}-icon.png`;
        const buttonId = targetButtonId;
        const imageType = "ICON-DEFAULT";
        changeButtonImage(buttonId, imageContent, imageType);
        isButtonIconPopup = false;
    };

    const clickCustomImage = () => {
        buttonImageBind.click();
    };

    const clickScenarioNavi = (scenario) => {
        bot.defaultChar.setActiveScenario(scenario.id);
        document
            .querySelector(`[data-target="${scenario.id}"]`)
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const clickScenarioDelete = (scenario) => {
        bot.defaultChar.deleteScenario(scenario);
    };

    const clickActionButtonNavi = () => {
        document
            .querySelector(".move-button-setting-wrap")
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
    };
</script>

{#if bot.defaultChar.scenarioList.length > 0}
    <div
        class="tw-space-y-4 tw-font-sans tw-text-foreground"
        class:tw-hidden={bot.currentTab !== "scenario"}
    >
        <!-- 페이지 네비게이션: 클릭하면 해당 페이지 카드로 스크롤 -->
        <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-1.5">
            {#each bot.defaultChar.scenarioList as scenario}
                <button
                    type="button"
                    class="tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-1.5 tw-rounded-full tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-transition-colors {scenario.active
                        ? 'tw-bg-primary/10 tw-text-primary'
                        : 'tw-bg-muted tw-text-muted-foreground hover:tw-text-foreground'}"
                    on:click={() => clickScenarioNavi(scenario)}
                >
                    {#if scenario.type === "START"}<span class="tw-h-1.5 tw-w-1.5 tw-rounded-full tw-bg-primary"></span>{/if}
                    {scenario.title}
                </button>
            {/each}
            <button
                type="button"
                class="tw-inline-flex tw-cursor-pointer tw-items-center tw-rounded-full tw-bg-muted tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-text-muted-foreground tw-transition-colors hover:tw-text-foreground"
                on:click={clickActionButtonNavi}
            >동작버튼</button>
            <button
                type="button"
                class="tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-1 tw-rounded-full tw-border tw-border-dashed tw-border-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-text-muted-foreground tw-transition-colors hover:tw-border-primary hover:tw-text-primary"
                on:click={clickScenarioAdd}
            >＋ 페이지 추가하기</button>
        </div>
        <div class="tw-space-y-4">
            <div class="tw-space-y-4">
                <!-- <div class="scenario-maker" style="display:none">
                <div class="talk-title">
                    <div class="scenario-name-form w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form-3-copy"
                            on:submit|preventDefault>
                            <input type="text" class="name-text-form _2 w-input" maxlength="256" name="name-4" data-name="Name 4" id="name-4" value={bot.defaultChar.activeScenario.title || ""} readonly={titleFlag} on:change={changeScenarioTitle}>
                            <div class="div-block-8" on:click={()=>titleFlag = !titleFlag}></div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="talk-description">
                    <div class="description">
                        <div class="tab-sub-text">캐릭터
                            대사<br><span class="text-span-4">캐릭터가 말하는 내용을 입력해주시면 됩니다.</span></div>
                        <div class="description-input">
                            <div class="description-input-form w-form">
                                <form id="email-form" name="email-form" data-name="Email Form" method="get"
                                    class="talk-form" on:click|preventDefault on:mouseleave={()=>
                                    changeCharacterDialog()}>
                                    <textarea class="name-text-form _3 w-input margin-top-7" value={bot.defaultChar.activeScenario.charMent || ""} maxlength="256" name="name-4" data-name="Name 4" placeholder="캐릭터가 말하는 내용을 입력해주세요!" id="name-4" on:change={()=>{changeCharacterDialog()}} />
                                    <EmojiSelector on:emoji={onEmoji} />
                                </form>
                                <div class="w-form-done">
                                    <div>Thank you! Your submission has been received!</div>
                                </div>
                                <div class="w-form-fail">
                                    <div>Oops! Something went wrong while submitting the form.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="motion">
                        <div class="tab-sub-text last">캐릭터 동작
                            연동<br><span class="text-span-4">시나리오에 맞는 캐릭터 동작을 선택해주시면 됩니다.</span>
                        </div>
                        <Select {floatingConfig} --font-size="13px" {itemId} {label} {searchable} items={bot.defaultChar.charActionList} value={bot.defaultChar?.getCharAction(bot.defaultChar.activeScenario.charAction)} on:select={changeCharAction}/>
                    </div>
                </div>
                <div class="talk-button">
                    <div class="tab-sub-text auto">스토리
                        버튼<br><span class="text-span-4">다음 단계로 넘어 갈 수 있는 버튼을 만들어서  캐릭터의 스토리를 이어갑니다.</span>
                    </div>
                    <ul class="talk-button-ul">
                    {#each bot.defaultChar.activeScenario.buttonList as button, index}
                    <li class="talk-button-wrap ordered-button" data-id={button.id} data-step="2">
                        <img src="/static/images/order-change-icon.svg" loading="lazy" alt="" class="order">
                        <div class="talk-button-input">
                            <div class="talk-input-form w-form" on:mouseleave={(e)=> changeButtonTitle(index)}>
                                <form id="email-form" name="email-form" data-name="Email Form" method="get" class="description-form-copy" on:submit|preventDefault>
                                    <textarea class="name-text-form _3 w-input" value={button.title || ""} bind:this={refButtonList[index]} maxlength="256" name="name-4" placeholder="버튼에 들어갈 내용을 적어주세요" id="name-4" on:change={(e) => changeButtonTitle(index)} on:click={()=>changeIframeButtonOutline('default', index)} on:mouseleave={()=>changeIframeButtonOutline('default')}/>
                                </form>
                                {#if button.buttonImageContent}
                                    <div class="file-upload-btn edit pointer" on:click={()=> clickButtonImageDelete(button.id)}>
                                        <div class="file-upload-text" on:click|stopPropagation={()=> clickButtonImageModify(button.id)}>버튼 이미지 보기</div>
                                    </div>
                                {:else}
                                <div class="scenario-plus button-image-wrapper pointer" on:click={()=> clickButtonImageCreate(button.id)}>
                                    <div class="scenario-plus-icon"></div>
                                    <div class="text-block-25">버튼 이미지 추가하기</div>
                                </div>
                                {/if}
                            </div>
                        </div>
                        <div class="talk-button-dropdown scenario-button" on:click={()=>changeIframeButtonOutline('default', index)} on:mouseleave={()=>changeIframeButtonOutline('default')}>
                            <Select {floatingConfig} --height="48px" --font-size="13px" containerStyles="margin-bottom:4px;" {searchable} items={items} on:select={event => changeButtonOption(event, index)} value={items.find(e => e.value === button.targetType)} />
                            {#if button.targetType === "SCENARIO"}
                            <Select {floatingConfig} --height="48px" --font-size="13px" {searchable} items={bot.defaultChar.scenarioList} on:select={event => changeScenario(event, index)} itemId={itemId} label={title} value={bot.defaultChar.scenarioList.find(e => e.id === button.targetScenarioId)} />
                            {:else}
                            <input type="text" class="scenario-text" value={button.targetLink || ""} on:change={event => changeButtonTargetLink(event, index, BUTTON_TYPE_DEFAULT, button.targetType)}/>
                            {/if}
                        </div>
                        {#if button.targetType === "SCENARIO"}
                        <div class="div-block-4 talk-button-next" on:click={()=>clickMoveScenario(button.targetScenarioId)}>
                            <div class="tooltiptext tooltip-top">연결한 다음 단계로 이동합니다.</div>
                        </div>
                        {:else}
                        <div class="talk-button-next" on:click={()=>window.open(button.targetLink, '_blank')}></div>
                        {/if}
                        <div class="delete-btn" on:click={()=>clickButtonDelete(index)}/>
                    </li>
                    {/each}
                    </ul>
                </div>
                <div class="scenario-plus-button pointer">
                    <div class="scenario-plus">
                        <div class="scenario-plus-icon"></div>
                        <div class="text-block-25" on:click={clickButtonAdd}>스토리버튼 추가하기</div>
                    </div>
                </div>
                {#if bot.defaultChar.activeScenario.type == 'START'}
                <div class="talk-button">
                    <div class="tab-sub-text auto">고정 버튼
                        <br><span class="text-span-4">시작스토리에서만 설정할 수 있으며, 아바톡 스토리 시 하단에 항상 보여지는 고정버튼 입니다.</span>
                    </div>
                    <ul class="talk-fixed-button-ul">
                    {#each bot.defaultChar.activeScenario.fixedButtonList as button, index}
                    <li class="talk-button-wrap fix-ordered-button" data-id={button.id} data-step="5">
                        <img src="/static/images/order-change-icon.svg" loading="lazy" alt="" class="order">
                        <div class="talk-button-input">
                            <div class="talk-input-form w-form" on:mouseleave={(e)=> changeButtonTitle(index, BUTTON_TYPE_FIX)}>
                                <form id="email-form" name="email-form" data-name="Email Form" method="get" class="description-form-copy" on:submit|preventDefault>
                                    <textarea class="name-text-form _3 w-input" value={button.title || ""} bind:this={refFixedButtonList[index]} maxlength="256" name="name-4" placeholder="버튼에 들어갈 내용을 적어주세요" id="name-4" on:change={(e) => changeButtonTitle(index, BUTTON_TYPE_FIX)} on:click={()=>changeIframeButtonOutline(BUTTON_TYPE_FIX, index)} on:mouseleave={()=>changeIframeButtonOutline(BUTTON_TYPE_FIX)}/>
                                </form>
                                {#if button.buttonImageContent}
                                <div class="file-upload-btn edit pointer" on:click={()=> clickButtonImageDelete(button.id)}>
                                    <div class="file-upload-text" on:click|stopPropagation={()=> clickButtonImageModify(button.id)}>버튼 이미지 보기</div>
                                </div>
                                {:else}
                                <div class="scenario-plus button-image-wrapper pointer" on:click={()=> clickButtonImageCreate(button.id)}>
                                    <div class="scenario-plus-icon"></div>
                                    <div class="text-block-25">버튼 이미지 추가하기</div>
                                </div>
                                {/if}
                            </div>
                        </div>
                        <div class="talk-button-dropdown scenario-button" on:click={()=>changeIframeButtonOutline(BUTTON_TYPE_FIX, index)} on:mouseleave={()=>changeIframeButtonOutline(BUTTON_TYPE_FIX)}>
                            <Select {floatingConfig} --font-size="13px" containerStyles="margin-bottom:4px;" {searchable} items={items} on:select={event => changeButtonOption(event, index, BUTTON_TYPE_FIX)} value={items.find(e => e.value === button.targetType)} />
                            {#if button.targetType === "SCENARIO"}
                            <Select {floatingConfig} --font-size="13px" items={bot.defaultChar.scenarioList} {searchable} on:select={(event) => changeScenario(event, index, BUTTON_TYPE_FIX)} itemId={itemId} label={title} value={bot.defaultChar.scenarioList.find(e => e.id === button.targetScenarioId)} />
                            {:else}
                            <input type="text" class="scenario-text" value={button.targetLink || ""} on:change={event => changeButtonTargetLink(event, index, BUTTON_TYPE_FIX, button.targetType)}/>
                            {/if}
                        </div>
                        {#if button.targetType === "SCENARIO"}
                        <div class="div-block-4 talk-button-next" on:click={()=>clickMoveScenario(button.targetScenarioId)}>
                            <div class="tooltiptext tooltip-top">연결한 다음 단계로 이동합니다.</div>
                        </div>
                        {:else}
                        <div class="talk-button-next" on:click={()=>window.open(button.targetLink, '_blank')}></div>
                        {/if}
                        <div class="delete-btn" on:click={()=>clickButtonDelete(index, BUTTON_TYPE_FIX)}/>
                    </li>
                    {/each}
                    </ul>
                </div>
                <div class="scenario-plus-button pointer">
                    <div class="scenario-plus">
                        <div class="scenario-plus-icon"></div>
                        <div class="text-block-25" on:click={() => clickButtonAdd(BUTTON_TYPE_FIX)}>고정버튼 추가하기</div>
                    </div>
                </div>
                {/if}
            </div> -->
                <div class="tw-rounded-xl tw-border tw-border-border tw-bg-card tw-p-5 tw-shadow-sm">
                    <div class="tw-flex tw-flex-col tw-items-center tw-gap-4">
                        <div class="tw-w-full tw-text-sm tw-font-semibold tw-text-foreground">
                            나만의 페이지 만들기
                        </div>
                        {#each bot.defaultChar.scenarioList as scenario}
                            <div
                                class="talk-scenario-box"
                                class:active-scenario={scenario.active}
                                data-target={scenario.id}
                                on:click={() =>
                                    bot.defaultChar.setActiveScenario(
                                        scenario.id,
                                    )}
                            >
                                <ScenarioBackground {bot} {scenario} />
                                {#if !scenario.isStart()}
                                    <img
                                        class="scenario-delete-button"
                                        loading="lazy"
                                        src="/static/images/scenario-trash.svg"
                                        on:click={() =>
                                            clickScenarioDelete(scenario)}
                                    />
                                {/if}
                                <ScenarioCharImage {bot} {scenario} />
                                <div class="charecter-talk">
                                    <ScenarioContext {bot} {scenario} />
                                </div>
                                <ScenarioButton
                                    {bot}
                                    {scenario}
                                    {clickIconImage}
                                    {clickButtonImageModify}
                                />
                                <div
                                    class="button-add-wrapper"
                                    on:click={() =>
                                        clickScenarioButtonAdd(scenario)}
                                >
                                    <div class="button-add-icon" />
                                    <div class="text-block-25">버튼 추가하기</div>
                                </div>
                            </div>
                        {/each}
                        <button
                            type="button"
                            class="tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-1.5 tw-rounded-lg tw-border tw-border-dashed tw-border-border tw-px-4 tw-py-2.5 tw-text-sm tw-font-medium tw-text-muted-foreground tw-transition-colors hover:tw-border-primary hover:tw-text-primary"
                            on:click={clickScenarioAdd}
                        >＋ 페이지 추가하기</button>
                        <div class="move-button-setting-wrap tw-w-full" data-step="3">
                            <div class="tw-mb-3 tw-mt-2 tw-text-sm tw-font-semibold tw-text-foreground">
                                동작 버튼 추가
                            </div>
                            <div
                                class="moving-image-con"
                                class:hide={!charActionFlag}
                            >
                                {#each bot.defaultChar.charActionList as charAction, index}
                                    <div class="move-btn-con">
                                        <img
                                            loading="lazy"
                                            src="/static/images/check-icon.svg"
                                            alt=""
                                            class="chracter-checkbox _3"
                                            class:active={charAction.isAddFlag()}
                                            on:click={() =>
                                                clickAddFlagCheckbox(
                                                    index,
                                                    charAction.addFlag,
                                                )}
                                        />
                                        <div class="div-block-90">
                                            <img
                                                class="image-edit"
                                                src="/static/images/image-edit-mini.svg"
                                                on:click={charImageModalList[
                                                    index
                                                ].clickCharActionChange(
                                                    charAction,
                                                )}
                                            />
                                            <CharImageModal
                                                bind:this={
                                                    charImageModalList[index]
                                                }
                                                {charAction}
                                                {bot}
                                            />
                                            <img
                                                class="char-image-wrapper"
                                                src={charAction.getImageUrl()}
                                                loading="lazy"
                                                alt=""
                                            />
                                        </div>
                                        <div class="moving-btn-name w-form">
                                            <div
                                                id="email-form"
                                                name="email-form"
                                                data-name="Email Form"
                                                method="get"
                                                class="moving-btn-form"
                                                data-wf-page-id="63088bc4cad86b3e17197960"
                                                data-wf-element-id="1cb7b2cf-d4e3-1e14-02db-16cec539b15a"
                                                aria-label="Email Form"
                                            >
                                                <input
                                                    type="text"
                                                    class="moving-text-form w-input"
                                                    data-index={index}
                                                    maxlength="256"
                                                    name="name-4"
                                                    data-name="Name 4"
                                                    placeholder="동작이름"
                                                    id="name-4"
                                                    value={charAction.actionName ||
                                                        ""}
                                                    on:change={changeBotActionName}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                {/each}
                                <div class="move-btn-con">
                                    <img
                                        class="action-button-img pointer"
                                        src="/static/images/a-plus-icon.svg"
                                        on:click={charImageModal.clickImageChoicePopup}
                                    />
                                    <CharImageModal
                                        bind:this={charImageModal}
                                        {imageUploadRef}
                                        {bot}
                                    />
                                    <input
                                        accept="image/png, image/jpeg, image/jpg, image/gif"
                                        bind:this={imageUploadRef}
                                        type="file"
                                        name="add"
                                        on:change={charImageModal.onImageFileUpload}
                                        hidden
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="tw-mb-3 tw-mt-4 tw-w-full tw-text-sm tw-font-semibold tw-text-foreground">
                            우측 링크 버튼 추가
                        </div>
                        <RightBlock {bot} />
                        <ChatLink {bot} />
                    </div>
                </div>
            </div>
            <input
                accept="image/png, image/jpeg, image/jpg, image/gif"
                bind:this={buttonImageBind}
                type="file"
                name="add"
                on:change={onImageFileSelected}
                hidden
            />
        </div>
    </div>
    {#if isButtonImagePopup}
    <div
        class="tw-fixed tw-inset-0 tw-z-[1100] tw-flex tw-items-center tw-justify-center tw-bg-black/50 tw-p-4 tw-font-sans"
        on:click={() => (isButtonImagePopup = false)}
    >
        <div
            class="tw-w-full tw-max-w-sm tw-rounded-xl tw-border tw-border-border tw-bg-card tw-p-6 tw-shadow-2xl"
            on:click|stopPropagation
        >
            <div class="tw-mx-auto tw-mb-5 tw-h-40 tw-w-40 tw-rounded-lg tw-border tw-border-border tw-bg-muted tw-bg-contain tw-bg-center tw-bg-no-repeat" style={`background-image:url("${buttonImageInfo.buttonImageContent}")`}></div>
            <div class="tw-text-sm tw-font-semibold tw-text-foreground">이미지 위치 선택</div>
            <div class="tw-mt-3 tw-grid tw-grid-cols-2 tw-gap-3">
                <button
                    type="button"
                    class="tw-cursor-pointer tw-rounded-lg tw-border tw-p-3 tw-text-center tw-transition-colors {buttonImageInfo.buttonImageType ==
                    'THUMBNAIL'
                        ? 'tw-border-primary tw-bg-primary/5'
                        : 'tw-border-border hover:tw-bg-muted'}"
                    on:click={() => (buttonImageInfo.buttonImageType = "THUMBNAIL")}
                >
                    <div class="tw-text-sm tw-font-medium tw-text-foreground">썸네일</div>
                    <div class="tw-mt-1 tw-text-xs tw-text-muted-foreground">버튼 위 썸네일 이미지 형</div>
                </button>
                <button
                    type="button"
                    class="tw-cursor-pointer tw-rounded-lg tw-border tw-p-3 tw-text-center tw-transition-colors {buttonImageInfo.buttonImageType ==
                    'ICON'
                        ? 'tw-border-primary tw-bg-primary/5'
                        : 'tw-border-border hover:tw-bg-muted'}"
                    on:click={() => (buttonImageInfo.buttonImageType = "ICON")}
                >
                    <div class="tw-text-sm tw-font-medium tw-text-foreground">아이콘</div>
                    <div class="tw-mt-1 tw-text-xs tw-text-muted-foreground">버튼 옆 아이콘 이미지 형</div>
                </button>
            </div>
            <div class="tw-mt-5 tw-flex tw-gap-2">
                <button
                    type="button"
                    class="tw-inline-flex tw-h-10 tw-flex-1 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-input tw-bg-background tw-text-sm tw-font-medium tw-text-foreground tw-transition-colors hover:tw-bg-muted"
                    on:click={clickButtonImageDelete}
                >삭제</button>
                <button
                    type="button"
                    class="tw-inline-flex tw-h-10 tw-flex-1 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-bg-primary tw-text-sm tw-font-medium tw-text-primary-foreground tw-transition-colors hover:tw-bg-primary/90"
                    data-button-id={targetButtonId}
                    on:click={() => clickButtonImageAssign()}
                >적용</button>
            </div>
        </div>
    </div>
    {/if}
    {#if isButtonIconPopup}
    <div
        class="tw-fixed tw-inset-0 tw-z-[1100] tw-flex tw-items-center tw-justify-center tw-bg-black/50 tw-p-4 tw-font-sans"
        on:click={() => (isButtonIconPopup = false)}
    >
        <div class="tw-relative tw-w-full tw-max-w-md tw-rounded-xl tw-border tw-border-border tw-bg-card tw-p-6 tw-shadow-2xl" on:click|stopPropagation>
            <div class="tw-text-sm tw-font-semibold tw-text-foreground">버튼에 적용할 이미지 선택</div>
            <div class="tw-mb-5 tw-mt-3 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-rounded-lg tw-border tw-border-dashed tw-border-border tw-bg-muted/40 tw-py-6">
                <img
                    src="/static/images/upload-icon-big.svg"
                    loading="lazy"
                    alt=""
                    class="tw-h-10 tw-w-10 tw-opacity-70"
                />
                <button
                    type="button"
                    class="tw-inline-flex tw-h-9 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-bg-primary tw-px-4 tw-text-sm tw-font-medium tw-text-primary-foreground tw-transition-colors hover:tw-bg-primary/90"
                    on:click={clickCustomImage}
                >이미지 파일 가져오기</button>
            </div>
            <div class="tw-mb-3 tw-text-sm tw-font-semibold tw-text-foreground">기본 아이콘 형태의 이미지 선택</div>
            <div class="div-block-89 tw-flex tw-flex-wrap tw-gap-2" on:click={clickIconImageSelected}>
                <img
                    bind:this={iconImageRef.insta}
                    data-type="insta"
                    src="/static/images/insta-icon.png"
                    loading="lazy"
                    width="54"
                    alt=""
                    class="icon-image"
                    class:checked-icon={iconImageList.insta}
                />
                <img
                    bind:this={iconImageRef.facebook}
                    data-type="facebook"
                    src="/static/images/facebook-icon.png"
                    loading="lazy"
                    alt=""
                    class="icon-image"
                    class:checked-icon={iconImageList.facebook}
                />
                <img
                    bind:this={iconImageRef.kakaotalk}
                    data-type="kakaotalk"
                    src="/static/images/kakaotalk-icon.png"
                    loading="lazy"
                    alt=""
                    class="icon-image"
                    class:checked-icon={iconImageList.kakaotalk}
                />
                <img
                    bind:this={iconImageRef.blog}
                    data-type="blog"
                    src="/static/images/blog-icon.png"
                    loading="lazy"
                    alt=""
                    class="icon-image"
                    class:checked-icon={iconImageList.blog}
                />
                <img
                    bind:this={iconImageRef.youtube}
                    data-type="youtube"
                    src="/static/images/youtube-icon.png"
                    loading="lazy"
                    alt=""
                    class="icon-image"
                    class:checked-icon={iconImageList.youtube}
                />
                <img
                    bind:this={iconImageRef.twitter}
                    data-type="twitter"
                    src="/static/images/twitter-icon.png"
                    loading="lazy"
                    alt=""
                    class="icon-image"
                    class:checked-icon={iconImageList.twitter}
                />
                <img
                    bind:this={iconImageRef.mail}
                    data-type="mail"
                    src="/static/images/mail-icon.png"
                    loading="lazy"
                    class="icon-image"
                    class:checked-icon={iconImageList.mail}
                />
                <img
                    bind:this={iconImageRef.shop}
                    data-type="shop"
                    src="/static/images/shop-icon.png"
                    loading="lazy"
                    alt=""
                    class="icon-image"
                    class:checked-icon={iconImageList.shop}
                />
            </div>
            <button
                type="button"
                class="tw-absolute tw-right-3 tw-top-3 tw-inline-flex tw-h-8 tw-w-8 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-text-muted-foreground tw-transition-colors hover:tw-bg-muted hover:tw-text-foreground"
                on:click={() => (isButtonIconPopup = false)}
                aria-label="닫기"
            >
                <svg class="tw-h-4 tw-w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
            </button>
            <div class="tw-mt-5 tw-flex tw-justify-end">
                <button
                    type="button"
                    class="tw-inline-flex tw-h-10 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-bg-primary tw-px-5 tw-text-sm tw-font-medium tw-text-primary-foreground tw-transition-colors hover:tw-bg-primary/90"
                    on:click={clickIconImageSubmit}
                >선택하기</button>
            </div>
        </div>
    </div>
    {/if}
{/if}

<style>
    /* 페이지 미리보기 카드 & 캐릭터 동작 그리드: 전역 Webflow CSS와 짝을 이루는 미리보기라 유지 */
    .char-image-wrapper {
        max-width: 100%;
        max-height: 100%;
    }
    .charecter-talk {
        position: relative;
    }
    .talk-scenario-box {
        position: relative;
        display: block;
    }
    .active-scenario {
        border: 2px solid #4c4fa7a6;
    }
    .scenario-delete-button {
        background-color: #d9d9d9;
        color: white;
        border-radius: 10px;
        position: absolute;
        right: 24px;
        top: 24px;
        z-index: 990;
        cursor: pointer;
    }
    .button-add-wrapper {
        display: flex;
        width: fit-content;
        height: 32px;
        margin: 6px auto 1px;
        padding: 7px;
        border-radius: 5px;
        background-color: #eaeaed;
        color: #99a3b7;
        font-weight: 500;
        cursor: pointer;
    }
    .button-add-icon {
        width: 18px;
        height: 18px;
        margin-right: 7px;
        background-image: url(https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/common/builder/images/plus-button.svg);
        background-size: contain;
        background-repeat: no-repeat;
    }
    .move-button-setting-wrap {
        width: 420px;
    }
    .moving-image-con {
        flex-flow: row wrap;
    }
    .move-btn-con {
        width: 95px;
        margin-bottom: 20px;
    }
    .div-block-90 {
        position: relative;
        height: 100px;
    }
    .image-edit {
        position: absolute;
        right: 5px;
        top: 5px;
        cursor: pointer;
    }
    .action-button-img {
        width: 32px;
    }
    .active {
        background-color: #4c4fa7;
    }
    .checked-icon {
        border: 2px solid #6372ff;
        border-radius: 5px;
    }
</style>
